import React from "react";

import InfoIcon from "@atlaskit/icon/glyph/info";
import sanitizeHtml from "sanitize-html";
import { useTheme } from "styled-components";

function Tooltip({ color, textColor, description }) {
  const theme = useTheme();

  return (
    <div
      style={{
        display: "grid",
        placeItems: "center",
        width: "100%",
      }}
    >
      <div title={description && sanitizeHtml(description)}>
        <span
          style={{
            fontSize: "30px",
            position: "relative",
            top: "5px",
            color: theme.text.text,
          }}
        >
          Tooltip
        </span>
        <InfoIcon
          primaryColor={color?.[theme.name]}
          secondaryColor={textColor?.[theme.name]}
          size="large"
        />
      </div>
    </div>
  );
}

export default Tooltip;
